// extracted by mini-css-extract-plugin
export default {"emptyContainer":"Mybooks_emptyContainer__UsY4B","container":"Mybooks_container__VFJvg"};